export const EMPTY_VALUE = '--';
export const EMPTY_ROUTE_DISTANCE_LABEL = '0km';
export const EMPTY_ROUTE_TRAVEL_TIME_LABEL = '0min.';
export const DEFAULT_STOP_SECONDS = 60;
export const MAX_SHIPPINGS_PER_ROUTING = 250;
export const MAX_LABELS_PER_PRINT = 50;
export const DELIVERY_WINDOW_HOURS_MS = 4 * 60 * 60 * 1000;
